import { ref as m, onBeforeUnmount as L, onBeforeMount as T } from "vue";
import { storeToRefs as b } from "pinia";
import { u as D } from "../stores/auth.al0TMRKc.js";
import { isPast as f, addMinutes as v } from "date-fns";
import g from "platform";
import { s as E } from "../lib/setRedirectCookie.BG84xRGr.js";
import { Hub as y } from "aws-amplify/utils";
const a = 20, S = 120, C = S * 2;
function R() {
  const p = D(), { user: i } = b(p), o = m(!1), t = m(a);
  let n;
  function r() {
    n && clearInterval(n);
  }
  function s() {
    r(), E(), o.value = !1, t.value = a, y.dispatch("authCustom", { event: "doLogout" });
  }
  function w() {
    r(), o.value = !1, t.value = a;
  }
  function h() {
    n = setInterval(() => {
      t.value > 0 ? t.value -= 1 : s();
    }, 1e3);
  }
  function I() {
    var l, c, d;
    const e = g.name === "Chrome Mobile" && ((l = g.os) == null ? void 0 : l.family) === "Android" && (((c = i.value.roles) == null ? void 0 : c.includes("cc-rota-user")) || ((d = i.value.roles) == null ? void 0 : d.includes("cc-rota-agency")));
    return console.debug(`isSharedDevice = ${e}`), e;
  }
  function u() {
    if (document.visibilityState === "hidden")
      localStorage.setItem("windowHidden", (/* @__PURE__ */ new Date()).getTime());
    else if (document.visibilityState === "visible") {
      const e = localStorage.getItem("windowHidden");
      localStorage.removeItem("windowHidden"), e !== void 0 && (f(
        v(
          new Date(parseInt(e, 10)),
          C
        )
      ) ? s() : f(
        v(new Date(parseInt(e, 10)), S)
      ) && (o.value = !0, h()));
    }
  }
  return L(() => {
    clearInterval(n), document.removeEventListener("visibilitychange", u, !1);
  }), T(() => {
    localStorage.removeItem("windowHidden"), I() && document.addEventListener("visibilitychange", u, !1);
  }), { user: i, showLogoutPrompt: o, secondsRemaining: t, logout: s, cancel: w };
}
export {
  R as u
};
